<div class="background-mask-group rounded-4">
  <div class="d-flex flex-column rounded-4 p-3 flex-lg-row justify-content-center align-items-lg-center h-100">
    <div class="col-lg-6 content-box text-lg-start text-white text-left">
      <div>
        <div class="font-page-heading text-uppercase font-size-20">{{ 'offer.page.title' | translate }}</div>
        <div class="font-default font-size-14">
          {{ 'offer.page.desc' | translate }}
        </div>
      </div>
      <div
        class="buttons font-heading font-size-14 bg-white btn-width text-black"
        id="buttonsContainer"
        [routerLink]="'/offers'"
      >
        <b>{{ 'offer.page.view.my.offers' | translate }}</b>
      </div>
    </div>
    <div class="col-lg-6 col-12"></div>
  </div>
</div>
